/**
 * Application configuration
 *
 * Vite exposes environment variables prefixed with VITE_ to client code.
 * Set these during build — see wrangler.toml.example for domain values.
 *
 * VITE_ENABLE_TEST_ROUTES controls /test/* routes:
 * - Local dev: defaults to true (always enabled)
 * - Staging: set to 'true' to enable
 * - Production: never set (routes disabled)
 */

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8787',
  // FALLBACK: ceetrix.com is the hosted service default. Self-hosters set VITE_LEGAL_BASE_URL at build time.
  legalBaseUrl: import.meta.env.VITE_LEGAL_BASE_URL || 'https://ceetrix.com',
  enableTestRoutes: import.meta.env.VITE_ENABLE_TEST_ROUTES === 'true' || import.meta.env.DEV,
} as const;
